export default "__VITE_ASSET__BDz6dKku__"